import { render, staticRenderFns } from "./CytologyLabTests.vue?vue&type=template&id=0209d618&scoped=true&"
import script from "./CytologyLabTests.vue?vue&type=script&lang=js&"
export * from "./CytologyLabTests.vue?vue&type=script&lang=js&"
import style0 from "./CytologyLabTests.vue?vue&type=style&index=0&id=0209d618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0209d618",
  null
  
)

export default component.exports